var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAUhgJCpv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-450.000000, -381.000000) translate(317.000000, 180.000000) translate(24.000000, 151.000000) translate(109.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B1A5DA",
    d: "M0 0L9 0 17 8 17 22 0 22z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 0L9 8 17 8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 2,
    x: 3,
    y: 13,
    fill: "#FFF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 2,
    x: 3,
    y: 17,
    fill: "#FFF",
    rx: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAUhgJCpv);
export default __webpack_public_path__ + "static/media/aUhgJCpv.207086cc51d4ba3eab5efce95f6d0502.svg";
export { ForwardRef as ReactComponent };